var PDF = require("../base/index");
function PDFPage(children, attributes, compress) {
    attributes = attributes || {};
    this.children = children;
    this.computedStyles = {
        size: 16,
        borderTopWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 1,
    };
    this.compress = compress || false;
    this.size = (attributes.size || "letter").toLowerCase();
    this.width = Number(attributes.width);
    this.height = Number(attributes.height);
    if (this.width && this.height && !attributes.orientation) {
        this.orientation = this.width > this.height ? "landscape" : "portrait";
    }
    else {
        this.orientation = (attributes.orientation || "portrait").toLowerCase();
    }
}
PDFPage.prototype.toString = function () {
    var str = "[" + this.constructor.name + " ";
    if (Array.isArray(this.children) && this.children.length) {
        str +=
            "\n" +
                this.children
                    .map(function (child) {
                    return child.toString("  ");
                })
                    .join(",\n") +
                "\n";
    }
    str += "]";
    return str;
};
function resolveStyles(node, styleManager) {
    styleManager.resolveStyles(node);
    if (Array.isArray(node.children)) {
        node.children.forEach(function (child) {
            resolveStyles(child, styleManager);
        });
    }
}
PDFPage.prototype.resolveStyles = function (styleManager) {
    if (Array.isArray(this.children)) {
        this.children.forEach(function (child) {
            resolveStyles(child, styleManager);
        });
    }
};
function computeStyles(node, styleManager) {
    styleManager.computeStyles(node);
    if (Array.isArray(node.children)) {
        node.children.forEach(function (child) {
            computeStyles(child, styleManager);
        });
    }
}
PDFPage.prototype.computeStyles = function (styleManager) {
    styleManager.computeStyles(this);
    if (Array.isArray(this.children)) {
        this.children.forEach(function (child) {
            computeStyles(child, styleManager);
        });
    }
    styleManager.collapseMargins(this);
};
PDFPage.prototype.getPDF = function () {
    if (this.width && this.height) {
        return new PDF({
            format: [this.width, this.height],
            orientation: this.width > this.height ? "landscape" : "portrait",
            compress: this.compress,
        });
    }
    else {
        var pageFormat = this.size || "letter";
        var pageOrientation = this.orientation || "portrait";
        return new PDF({ format: pageFormat, orientation: pageOrientation, compress: this.compress });
    }
};
PDFPage.prototype.addPage = function (pdf) {
    var pageFormat = this.size || "letter";
    var pageOrientation = this.orientation || "portrait";
    if (this.width && this.height) {
        pageFormat = this.width;
        pageOrientation = this.height;
    }
    // return new PDF({format: pageFormat, orientation: pageOrientation});
    pdf.doc.addPage(pageFormat, pageOrientation);
};
PDFPage.prototype.getBlock = function (pdf) {
    if (!pdf)
        pdf = this.getPDF();
    var pageDimensions = PDF.pageSizes[this.size].slice(0);
    if (this.orientation === "landscape" && pageDimensions[0] < pageDimensions[1]) {
        pageDimensions.reverse();
    }
    return pdf.block({ width: pageDimensions[0], height: pageDimensions[1] }, this.children.map(function (child) {
        return child.generate(pdf);
    }));
};
PDFPage.prototype.generate = function (pdf) {
    if (!pdf)
        pdf = this.getPDF();
    pdf.draw(this.getBlock(pdf));
    return pdf;
};
module.exports = PDFPage;
//# sourceMappingURL=module.js.map